export const adaptIndicacion = (indicacion) => {
    return {
        idIndicacionRI: indicacion?.idIndicacionRI,
        idInsumo: indicacion?.idInsumo,
        nombreInsumo: indicacion?.idInsumoNavigation?.descripcion,
        cantidadDiaria: indicacion?.cantidadDiaria,
        unidad: indicacion?.idInsumoNavigation?.idUnidadNavigation?.alias,
        eleccion: indicacion?.idInsumoNavigation?.eleccion,
    }
}

export const adaptIndicacionesArray = (
    indicaciones
) => {
    return structuredClone(indicaciones?.indicacionesRIByIdPantallaRI)
        ?.map(indicacion => adaptIndicacion(indicacion));
}